import { render, staticRenderFns } from "./FeedbackActions.vue?vue&type=template&id=04c3545d&scoped=true"
import script from "./FeedbackActions.vue?vue&type=script&lang=js"
export * from "./FeedbackActions.vue?vue&type=script&lang=js"
import style0 from "./FeedbackActions.vue?vue&type=style&index=0&id=04c3545d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3545d",
  null
  
)

export default component.exports